/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { KokpitFeatureNameListDto } from './KokpitFeatureNameListDto';
import {
    KokpitFeatureNameListDtoFromJSON,
    KokpitFeatureNameListDtoFromJSONTyped,
    KokpitFeatureNameListDtoToJSON,
} from './KokpitFeatureNameListDto';

/**
 * 
 * @export
 * @interface KokpitPackageListDto
 */
export interface KokpitPackageListDto {
    /**
     * 
     * @type {number}
     * @memberof KokpitPackageListDto
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof KokpitPackageListDto
     */
    id?: number;
    /**
     * Ekleyenin Tam İsmi
     * @type {string}
     * @memberof KokpitPackageListDto
     */
    createdByFullName?: string | null;
    /**
     * Güncelleyenin Tam İsmi
     * @type {string}
     * @memberof KokpitPackageListDto
     */
    modifiedByFullName?: string | null;
    /**
     * Eklenme Tarihi
     * @type {Date}
     * @memberof KokpitPackageListDto
     */
    createdAt?: dayjs.Dayjs;
    /**
     * Güncelleme Tarihi
     * @type {Date}
     * @memberof KokpitPackageListDto
     */
    modifiedAt?: dayjs.Dayjs;
    /**
     * 
     * @type {string}
     * @memberof KokpitPackageListDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KokpitPackageListDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<KokpitFeatureNameListDto>}
     * @memberof KokpitPackageListDto
     */
    features?: Array<KokpitFeatureNameListDto> | null;
}

/**
 * Check if a given object implements the KokpitPackageListDto interface.
 */
export function instanceOfKokpitPackageListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KokpitPackageListDtoFromJSON(json: any): KokpitPackageListDto {
    return KokpitPackageListDtoFromJSONTyped(json, false);
}

export function KokpitPackageListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KokpitPackageListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdByFullName': !exists(json, 'createdByFullName') ? undefined : json['createdByFullName'],
        'modifiedByFullName': !exists(json, 'modifiedByFullName') ? undefined : json['modifiedByFullName'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (dayjs(json['createdAt'])),

        'modifiedAt': !exists(json, 'modifiedAt') ? undefined : (dayjs(json['modifiedAt'])),

        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'features': !exists(json, 'features') ? undefined : (json['features'] === null ? null : (json['features'] as Array<any>).map(KokpitFeatureNameListDtoFromJSON)),
    };
}

export function KokpitPackageListDtoToJSON(value?: KokpitPackageListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'id': value.id,
        'createdByFullName': value.createdByFullName,
        'modifiedByFullName': value.modifiedByFullName,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'modifiedAt': value.modifiedAt === undefined ? undefined : (value.modifiedAt.toISOString()),
        'name': value.name,
        'description': value.description,
        'features': value.features === undefined ? undefined : (value.features === null ? null : (value.features as Array<any>).map(KokpitFeatureNameListDtoToJSON)),
    };
}

